import styled from 'styled-components';

import { smallShadow, colors } from 'ui/theme';
import { layoutLRPadding, layoutTopPadding, base } from 'ui/theme/spacing';
import { PageHeader } from 'ui/pageHeader';
import { Link } from 'ui/links';
import { AdAccountHeaderPageActions } from './AdAccountHeaderPageActions';
import { FACEBOOK_INTEGRATION_URL } from '../../constants';
import { useFbcaTranslations } from '../../hooks/useTranslations';

const StyledLink = styled(Link)`
  padding: 20px;
`;

const PageContainer = styled.div`
  padding: ${layoutTopPadding} ${layoutLRPadding} ${base} ${layoutLRPadding};
  background-color: ${colors.backgroundPrimary};
  ${smallShadow};
`;

export const SelectAdAccountHeader = () => {
  const { t } = useFbcaTranslations();

  return (
    <PageContainer>
      <StyledLink variant="monochrome" href={FACEBOOK_INTEGRATION_URL}>
        {t('header.link')}
      </StyledLink>
      <PageHeader pageActions={<AdAccountHeaderPageActions />}>
        {t('header.selectLabel')}
      </PageHeader>
    </PageContainer>
  );
};
